import React from 'react';
import { AlertCircleIcon, ArrowRightIcon, HeartCrackIcon, MessageCircleHeartIcon, PawPrintIcon, StarIcon } from 'lucide-react';
const WEBINAR_URL = '/webinar-mc-adv4-pmax?v=spl2';
const benefits = [{
  icon: AlertCircleIcon,
  text: 'De #1 fout die zelfs de meest liefdevolle baasjes maken - en die bijna elke klassieke hondenschool aanleert'
}, {
  icon: HeartCrackIcon,
  text: 'Waarom je hond na een correctie onzekerder wordt in plaats van gehoorzamer'
}, {
  icon: MessageCircleHeartIcon,
  text: 'De eerste stap naar een rustigere, zekerdere hond: communiceren in zijn eigen taal'
}];
function PawMessageIcon() {
  return <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[#e9f0fb] text-[#3569B4]" aria-hidden="true" data-id="element-3025" data-mp="bdhvwfpo0j5b">
      <MessageCircleHeartIcon className="h-5 w-5" data-id="element-3026" data-mp="qbk3r23qbqsd" />
      <PawPrintIcon className="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full bg-[#e9f0fb] p-0.5" data-id="element-3027" data-mp="lbntwm8cp54w" />
    </span>;
}
export function OnzekereHondSpl2Page() {
  return <main className="min-h-screen w-full overflow-hidden bg-[#FAF7F2] font-sans text-[#171716]" data-id="element-3028" data-mp="ftujkhjn94cg">
      <section className="mx-auto flex min-h-screen max-w-7xl flex-col px-5 py-5 sm:px-8 lg:grid lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-12 lg:px-12 lg:py-10" data-id="element-3029" data-mp="ksywnj9ovm82">
        <div className="mx-auto flex w-full max-w-[620px] flex-col lg:order-1 lg:mx-0" data-id="element-3030" data-mp="tsc9mlx0usxj">
          <div className="mb-5 flex justify-center lg:justify-start" data-id="element-3031" data-mp="ypkniab50asz">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-auto w-full max-w-[120px] object-contain" data-id="element-3032" data-mp="13p732qefu34y" />
          </div>

          <p className="text-center text-[10px] font-extrabold tracking-[0.14em] text-[#3569B4] sm:text-xs lg:text-left" data-id="element-3033" data-mp="1hh58aq513evu">
            GRATIS ONLINE WEBINAR VOOR BAASJES VAN ONZEKERE HONDEN
          </p>

          <h1 className="mt-3 text-center font-rounded text-[30px] font-extrabold leading-[1.13] tracking-[-0.035em] text-[#171716] sm:text-[34px] lg:text-left lg:text-[42px]" data-id="element-3034" data-mp="3ij3bntrs1e3x">
            De #1 fout waardoor jouw hond onzeker blijft - en wat je in plaats daarvan doet
          </h1>

          <p className="mt-4 text-center text-[17px] leading-[1.5] text-[#625f5a] sm:text-[18px] lg:text-left lg:text-[19px]" data-id="element-3035" data-mp="3sazcvdp5tkcd">
            Gediplomeerd hondengedragsconsultant Amee onthult waarom goedbedoeld
            corrigeren averechts werkt - en leert je de taal die je hond van
            nature wél begrijpt.
          </p>

          <figure className="mt-5 block overflow-hidden rounded-2xl shadow-[0_14px_35px_rgba(76,57,40,0.12)] lg:hidden" data-id="element-3036" data-mp="f2w7zn9d3gv5">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/7c658c7a-7bf0-486e-a2ea-dc6e68aadcf9.jpg" alt="Baasje zit ontspannen met haar hond in het avondlicht" className="h-36 w-full object-cover object-center" data-id="element-3037" data-mp="a4unqz079bi3" />
          </figure>

          <ul className="mt-5 space-y-3.5 sm:mt-6" data-id="element-3038" data-mp="rddrker0v4yf">
            {benefits.map(({
            icon: Icon,
            text
          }, index) => <li key={text} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-[#353330] sm:text-base" data-id="element-3039" data-mp="wb6yxb42a50a" data-mpi={index}>
                {index === 2 ? <PawMessageIcon data-id="element-3040" data-mp="mjsow9ehhmsw" /> : <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#e9f0fb] text-[#3569B4]" aria-hidden="true" data-id="element-3041" data-mp="8lkxeh07vdp4">
                    <Icon className="h-5 w-5" data-id="element-3042" data-mp="3uuvuq8vunnsi" />
                  </span>}
                <span className="pt-1.5" data-id="element-3043" data-mp="3ocgejqt1fpg">{text}</span>
              </li>)}
          </ul>

          <a href={WEBINAR_URL} className="mt-6 flex min-h-14 w-full items-center justify-center gap-2 rounded-xl bg-[#E8762D] px-5 py-4 text-center text-[17px] font-extrabold text-white shadow-[0_8px_18px_rgba(188,91,35,0.24)] transition duration-200 hover:scale-[1.015] hover:bg-[#cf6525] focus:outline-none focus:ring-4 focus:ring-[#f8c8aa] sm:mt-7" data-id="element-3044" data-mp="1t3iuhx4tu42s">
            Ja, ik wil het gratis webinar zien
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-3045" data-mp="3l5v7m547jp9o" />
          </a>
          <p className="mt-2 text-center text-[13px] text-[#817c75]" data-id="element-3046" data-mp="3g4fq2n18o0w1">
            100% gratis · Online te bekijken · Direct toe te passen
          </p>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-t border-[#e7dfd4] pt-4 lg:justify-start" data-id="element-3047" data-mp="36eclrqoo30ie">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee, gediplomeerd hondengedragsconsultant" className="h-9 w-9 rounded-full object-cover" data-id="element-3048" data-mp="32dstb0f1gl2l" />
            <span className="text-[13px] font-semibold text-[#57534e]" data-id="element-3049" data-mp="2ngjtrjfl0azs">
              Door Amee, gediplomeerd hondengedragsconsultant
            </span>
            <span className="flex items-center gap-0.5 text-[#E8762D]" aria-label="5 sterren op Trustpilot" data-id="element-3050" data-mp="2iawmc42j7upa">
              {Array.from({
              length: 5
            }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-3051" data-mp="2s9vr3bk6f670" />)}
            </span>
            <span className="text-[12px] text-[#77716a]" data-id="element-3052" data-mp="1zjvmldtl7v4o">
              4.3 op Trustpilot · 100.000+ hondenbaasjes gingen je voor
            </span>
          </div>
        </div>

        <div className="relative hidden lg:order-2 lg:block" data-id="element-3053" data-mp="29ahyoy23i3im">
          <div className="absolute -inset-7 rounded-[2rem] bg-[#e8dbc9]" aria-hidden="true" data-id="element-3054" data-mp="29bsyynwc0t4z" />
          <figure className="relative overflow-hidden rounded-2xl shadow-[0_20px_45px_rgba(76,57,40,0.16)]" data-id="element-3055" data-mp="1gu780va1mrbh">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/7c658c7a-7bf0-486e-a2ea-dc6e68aadcf9.jpg" alt="Baasje zit ontspannen met haar hond in het avondlicht" className="h-[590px] w-full object-cover" data-id="element-3056" data-mp="18t7wousy1m8b" />
          </figure>
        </div>

        <div className="mt-auto pt-5 text-center text-xs text-[#918b83] lg:col-span-2 lg:pt-6" data-id="element-3057" data-mp="1djobojcexfws">
          © Stressless Dogs ·{' '}
          <a href="#privacy" className="underline underline-offset-2 hover:text-[#625f5a]" data-id="element-3058" data-mp="pveujuq59gbz">
            Privacyverklaring
          </a>
        </div>
      </section>

      <section className="hidden border-t border-[#e7dfd4] bg-[#f5efe7] px-5 py-7 md:block" data-id="element-3059" data-mp="ztkx8ejryqhw">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-6" data-id="element-3060" data-mp="usx5fqnq25mm">
          <p className="font-rounded text-lg italic text-[#49443e]" data-id="element-3061" data-mp="2b76r2d0kxg9r">
            “Eindelijk begrijp ik wat mijn hond me al die tijd probeerde te vertellen.”
            <span className="ml-2 text-sm not-italic text-[#77716a]" data-id="element-3062" data-mp="26b82aobc9w8t">
              - Sandra &amp; Max
            </span>
          </p>
          <a href={WEBINAR_URL} className="shrink-0 rounded-lg border border-[#d96a27] px-5 py-3 text-sm font-extrabold text-[#c55d21] transition hover:bg-[#E8762D] hover:text-white focus:outline-none focus:ring-4 focus:ring-[#f8c8aa]" data-id="element-3063" data-mp="2irr5e9e9osri">
            Ja, ik wil het gratis webinar zien
          </a>
        </div>
      </section>
    </main>;
}